import { useFetcher } from '@remix-run/react'
import { useEffect, useState } from 'react'
import { type action as upscaleAction } from '#app/routes/_app+/me+/upscale.ts'
import { useJsonEventSource } from './use-json-event-source.ts'

export function useGetUpscaleImage() {
	const [upscale, setUpscale] = useState<any>()
	const fetcher = useFetcher<typeof upscaleAction>()

	const sourceUpscaleSuccess = useJsonEventSource('upscaleImageSuccess')

	useEffect(() => {
		if (!sourceUpscaleSuccess) return
		if (
			sourceUpscaleSuccess.predictionId === upscale?.predictionId &&
			!upscale?.url
		) {
			setUpscale(sourceUpscaleSuccess)
		}
	}, [sourceUpscaleSuccess, upscale?.predictionId, upscale?.url])

	useEffect(() => {
		if (fetcher.data) {
			setUpscale(fetcher.data.prediction)
		}
	}, [fetcher.data])

	return { upscale, fetcher }
}
